import { mmss } from './ui.js';

// Плеер записи. Штатные controls у <audio> не дают ни скорости, ни внешней
// перемотки по таймкоду из разбора, поэтому свой — благо это немного кода.
// Перемотку обеспечивает сервер: он отдаёт запись с поддержкой Range.

export const Player = {
  props: {
    src: { type: String, required: true },
    /** { at: секунды, nonce } — перемотка снаружи, по клику в разборе. */
    seekTo: { type: Object, default: null },
  },
  data() {
    return { playing: false, current: 0, duration: 0, rate: 1, ready: false, error: '' };
  },
  watch: {
    seekTo(v) { if (v) this.seek(v.at, true); },
    rate(v) { if (this.$refs.audio) this.$refs.audio.playbackRate = v; },
  },
  methods: {
    mmss,

    onMeta() {
      this.duration = this.$refs.audio.duration || 0;
      this.ready = true;
    },

    toggle() {
      const a = this.$refs.audio;
      if (!a) return;
      if (a.paused) { a.play().catch((e) => { this.error = e.message; }); }
      else a.pause();
    },

    /** @param {boolean} andPlay перемотка из разбора сразу начинает играть */
    seek(seconds, andPlay = false) {
      const a = this.$refs.audio;
      if (!a) return;
      const apply = () => {
        a.currentTime = Math.max(0, Math.min(seconds, a.duration || seconds));
        if (andPlay) a.play().catch(() => {});
      };
      // Метаданные могли ещё не приехать: без duration перемотка молча не сработает.
      if (a.readyState >= 1) apply();
      else a.addEventListener('loadedmetadata', apply, { once: true });
    },

    skip(delta) { this.seek(this.current + delta); },

    scrub(event) {
      const rect = event.currentTarget.getBoundingClientRect();
      const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
      this.seek(ratio * this.duration);
    },
  },
  template: `
    <div class="player">
      <audio ref="audio" :src="src" preload="metadata"
             @loadedmetadata="onMeta"
             @timeupdate="current = $refs.audio.currentTime"
             @play="playing = true" @pause="playing = false"
             @error="error = 'запись не загрузилась'"></audio>

      <div class="row">
        <button @click="toggle" :disabled="!ready" style="min-width:96px">
          {{ playing ? '⏸ Пауза' : '▶ Слушать' }}
        </button>
        <button class="sm ghost" @click="skip(-10)" :disabled="!ready">−10с</button>
        <button class="sm ghost" @click="skip(10)" :disabled="!ready">+10с</button>
        <span class="spacer"></span>
        <select class="inline" v-model.number="rate" title="скорость воспроизведения">
          <option :value="0.75">×0.75</option>
          <option :value="1">×1</option>
          <option :value="1.25">×1.25</option>
          <option :value="1.5">×1.5</option>
          <option :value="1.75">×1.75</option>
          <option :value="2">×2</option>
        </select>
      </div>

      <div class="bar" @click="scrub">
        <div class="fill" :style="{ width: (duration ? current / duration * 100 : 0) + '%' }"></div>
        <div class="knob" :style="{ left: (duration ? current / duration * 100 : 0) + '%' }"></div>
      </div>

      <div class="times">
        <span>{{ mmss(current) }}</span>
        <span v-if="error" class="err">{{ error }}</span>
        <span>{{ mmss(duration) }}</span>
      </div>
    </div>`,
};
